import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import Login from './auth_components/js/Login';
import Signup from './auth_components/js/Signup';

import MainHome from './HomeComponents/MainHome';
import News from './HomeComponents/News/News';
import DashBoard from './HomeComponents/DashBoard';
import Event from './HomeComponents/Events/Events';
import Notice from './HomeComponents/Notice/Notice';
import Tender from './HomeComponents/Tender/Tender';
import CheckNews from './HomeComponents/CheckNews';

class App extends Component {
  render() {
    return (
      <Router>

        <div>
          <Switch>
            <Route exact name="login" path="/login" component={Login} />
            <Route exact name="signup" path="/signup" component={Signup} />
            <Route exact name="home" path="/" component={MainHome} />
            <Route exact name="news" path="/news" component={News} />
            <Route exact name="event" path="/events" component={Event} />
            <Route exact name="notice" path="/notice" component={Notice} />
            <Route exact name="tender" path="/tender" component={Tender} />
            <Route exact name="checknews" path="/newsc" component={CheckNews} />
          </Switch>
        </div>

      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js